import { ReactNode } from "react"
import { getIconWithOption } from "./OptionIcon"

export type Options = Readonly<{
    keys: string[]
    options: Option[]
}>

export type Option = Readonly<{
    key: string
    name: string
    values: { [key: string]: boolean }
    cellCssClass: string
    icon: ReactNode
    dropDownIcon?: ReactNode
}>

export const notAvailableOption: Option = {
    key: "",
    name: "Not available",
    values: { },
    cellCssClass: "not-available",
    icon: "fa-solid fa-lock",
}

const readOption: Option = {
    key: "read",
    name: "View",
    values: { read: true },
    cellCssClass: "read",
    icon: "fa-solid fa-eye",

}

const writeOption: Option = {
    key: "read,write",
    name: "View and edit",
    values: { read: true, write: true },
    cellCssClass: "write",
    icon: "fas fa-pen",
}

export const accessOptions: Options = {
    keys: ["enabled"],
    options: [
        {
            key: "enabled",
            name: "Available",
            values: { enabled: true },
            cellCssClass: "available",
            icon: "fa-solid fa-circle-check"
        },
        notAvailableOption
    ]
}

export const readWriteOptions: Options = {
    keys: ["read", "write"],
    options: [
        readOption,
        writeOption,
        notAvailableOption
    ]
}

export const readWriteWithFinancialDataOptions: Options =
{
    keys: ["read", "write", "financialData"],
    options: [
        readOption,
        {

            key: "read,financialData",
            name: "View (including financial data)",
            values: { read: true, financialData: true },
            icon: getIconWithOption("fa-solid fa-eye", "fa-solid fa-sterling-sign"),
            cellCssClass: "read-financial"
        },
        // 240506 - Removing this option, as there is no way to grant write access without financial data access
        // writeOption,
        {

            key: "read,write,financialData",
            name: "View and edit (including financial data)",
            values: { read: true, write: true, financialData: true },
            icon: getIconWithOption("fas fa-pen", "fa-solid fa-sterling-sign"),
            cellCssClass: "write-financial"
        },
        notAvailableOption
    ]
}